// Full-document render of the Oscar account order-detail view: PageSkeleton
// wrapping the legacy sealy orders page -- the "Your Account / Your Orders /
// {number}" breadcrumbs, the "Order: {number}" heading, the shared
// RichOrderDetail block (typed-serialized server-side), and the
// customer-service info block. The order-details toggle is owned by the shared
// block's own disclosure state (collapsible).
import React from "react";
import { RichOrderDetail } from "tsi-common-react/src/apps/customer-account/RichOrderDetail/index";

import { templates } from "@reactivated";

import { CustomerServiceInfoBlock } from "../components/CustomerServiceInfoBlock";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.OrderDetailDocumentTemplate,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="l-capped-width u-margin-bottom--xl u-full-width-title order-list">
                <section className="breadcrumbs-block">
                    <a href={props.profile_url}>Your Account</a> /{" "}
                    <a href={props.order_list_url}>Your Orders</a> /{" "}
                    {props.order_number}
                </section>

                <h2>Order: {props.order_number}</h2>

                <div className="content__copy--full-width content__orders-page">
                    <div className="orders">
                        <ul className="orders__list">
                            <li className="orders__list-item">
                                <div className="content__copy--full-width order-summary-wrapper">
                                    {/* rich_order_detail is the sealy shape;
                                        the shared template types it nullable
                                        (other sites render order_detail), but
                                        on sealy it is always populated. */}
                                    {props.rich_order_detail && (
                                        <RichOrderDetail
                                            {...props.rich_order_detail}
                                            collapsible={true}
                                        />
                                    )}
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            {props.cs_info && <CustomerServiceInfoBlock info={props.cs_info} />}
        </PageSkeleton>
    );
};
